import {Pill} from '@wandb/weave/components/Tag';
import React from 'react';

import {PRIORITY_LEVEL_METADATA} from './constants';

type PriorityProps = {
  value: number;
};

export const Priority = ({value}: PriorityProps) => {
  const meta = PRIORITY_LEVEL_METADATA[value] ?? PRIORITY_LEVEL_METADATA[2]; // Default: medium
  const {color, icon, label} = meta;

  return <Pill label={label} color={color} icon={icon} />;
};
